import React from "react";
import style from "./index.module.scss";
import { message, Steps } from "antd";
import { waitForAll } from "jotai/utils";
import { useAtomValue, useSetAtom } from "jotai";
import {
    emptyFormAtom,
    FlagAtom,
    ShowConfirmAtom,
    StepOneStateAtom,
    StepStateAtom,
    TouchedAtom
} from "../../../../store";
import { activityBaseInfoItem } from "service/group";

const { Step } = Steps;

interface StepProgress {
    item?: activityBaseInfoItem; //当前项
    step: number;
    onChangeStep: (val: number) => void;
    activityId: number; //活动id
}

export default function StepProgress({
    item,
    step: current,
    onChangeStep,
    activityId
}: StepProgress) {
    const setEmptyForm = useSetAtom(emptyFormAtom);
    const setShowConfirm = useSetAtom(ShowConfirmAtom);
    const setStepState = useSetAtom(StepStateAtom);
    const setStepOneStateAtom = useSetAtom(StepOneStateAtom);
    const [touched, flag] = useAtomValue(waitForAll([TouchedAtom, FlagAtom]));

    const onChange = (step: number) => {
        if (!!item && !item?.groupIds) {
            message.warning("请选择参与小组后点击保存");
            return;
        }

        if (activityId !== -1) {
            if (touched) {
                setShowConfirm(true);
                switch (current) {
                    case 0:
                        setStepOneStateAtom(
                            step === 1 ? "next" : "nextTwoStep"
                        );
                        break;
                    case 1:
                        setStepState(step === 0 ? "waitPrev" : "waitNext");
                        break;
                }

                return;
            }
            onChangeStep(step);
            setEmptyForm(false);
        } else {
            message.info("请先添加活动");
        }
    };

    const stepsIcon = (step: number) => {
        if (current < step) {
            return <img src={require(`./img/step${step}.png`)} />;
        } else if (current === step) {
            return <img src={require(`./img/step${step}-active.png`)} />;
        } else {
            return <img src={require(`./img/success.png`)} />;
        }
    };

    return (
        <div className={style.root}>
            <Steps
                current={current}
                onChange={onChange}
                labelPlacement="vertical">
                <Step
                    title={flag === "add" ? "添加活动" : "编辑活动"}
                    icon={stepsIcon(0)}
                />
                <Step
                    title={flag === "add" ? "添加任务" : "编辑任务"}
                    icon={stepsIcon(1)}
                />
                <Step title="发布预览" icon={stepsIcon(2)} />
            </Steps>
        </div>
    );
}
